import {useBootstrapDataStore} from '@ui/bootstrap-data/bootstrap-data-store';
import {useLocaleLinesStore} from '@ui/i18n/locale-lines-store';

export function useSelectedLocale() {
  const data = useBootstrapDataStore(s => s.data);
  const localeCode = data?.i18n?.active || 'en';
  const loaded = useLocaleLinesStore(s => s.lines[localeCode]);
  const selected = data?.i18n?.locales.find(l => l.language === localeCode);
  return {
    localeName: selected?.name,
    localeCode,
    // build 131: lines come from the cached JSON; embedded lines (mobile
    // bootstrap) still work as a fallback
    lines: loaded ?? selected?.lines,
  };
}
